import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Layout as AntLayout } from 'antd';
import * as Sentry from '@sentry/react';
import { setRequestPage } from 'utils/requestSource';
import ActionBarLayout from 'components/ActionbarLayout';
import GlobalTaskModal from './components/GlobalTaskModal';
import GlobalClientModal from './components/GlobalClientModal';
import GlobalProfileModal from './components/GlobalProfileModal';
import GlobalTeamSurveyToast from './components/GlobalTeamSurveyToast';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import { getAllRoutes } from './components/Sidebar/config';
import useCountUnreadInbox from './useCountUnreadInbox';
import AppHeader from '../AppHeader';
import style from './layout.module.less';

interface AppLayoutProps {
  overflowScroll?: boolean;
}

const Layout: FC<AppLayoutProps> = ({ overflowScroll, children }) => {
  const { pathname, search } = useLocation();
  const pathConfig = getAllRoutes();
  const activeRoute = pathConfig.find(
    (el) => el.path && ((el.path === '/' && el.path === pathname) || (el.path !== '/' && pathname.startsWith(el.path))),
  );

  useEffect(() => {
    setRequestPage(pathname + search);
    Sentry.setTag('app.page', pathname + search);
  }, [pathname, search]);

  useCountUnreadInbox();

  return (
    <AntLayout className={style.layout}>
      <GlobalTaskModal />
      <GlobalClientModal />
      <GlobalProfileModal />
      <GlobalTeamSurveyToast />

      <Header activeRoute={activeRoute} />

      <AppHeader activeRoute={activeRoute} />

      <AntLayout>
        <Sidebar activeRoute={activeRoute} />

        <ActionBarLayout overflowScroll={overflowScroll}>{children}</ActionBarLayout>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
